import { Box, Button } from "@mui/material";
import { H4, Small } from "../components/Typography";
import { FC } from "react";
import DoneIcon from "@mui/icons-material/Done";
interface UploadCardProps {
  title: any;
  subTitle: any;
  onClick: any;
  description: any;
  uploaded: boolean;
}

const UploadVideo: FC<UploadCardProps> = ({
  title,
  subTitle,
  onClick,
  description,
  uploaded,
}) => {
  return (
    <Box sx={mainContainer}>
      <Box sx={sxStyleBox2}>
        <Box>
          <H4 sx={sxStyleH3} color="#595959">
            {title}
            <H4 color="#f00">*</H4>
          </H4>
          <Small
            fontWeight={400}
            fontSize={10}
            sx={sxStyleSmall}
            color="#595959"
          >
            {subTitle}
          </Small>
        </Box>
        {uploaded ? (
          <Button  onClick={onClick} variant="contained" component="label" sx={uploadedView}>
            <DoneIcon style={{ color: "#fff" }} />
          </Button>
        ) : (
          <Button  onClick={onClick} variant="contained" component="label" sx={buttonView}>
            Upload
          </Button>
        )}
      </Box>
      <Small fontWeight={400} fontSize={10} sx={sxStyleSmall} color="#595959">
        {description}
      </Small>
    </Box>
  );
};

export default UploadVideo;
const sxStyleBox2 = {
  flexDirection: "row",
  alignItems: "center",
  borderRadius: 1.2,
  justifyContent: "space-between",
  display: "flex",
};
const mainContainer = {
  width: {
    xs: "90%",
    sm: "90%",
    md: "46%",
  },
  border: "0.5px solid #E8E8E8",
  alignItems: "center",
  borderRadius: 1.2,
  padding: 2,
  justifyContent: "space-between",
  marginTop: {
    xs: 2,
    sm: 2,
    md: 0,
  },
};
const buttonView = {
  border: "0.5px solid #E8E8E8",
  flexDirection: "row",
  display: "flex",
  alignItems: "center",
  borderRadius: 5,
  padding: 0.5,
  paddingLeft: 2,
  color: "#000",
  paddingRight: 2,
  backgroundColor: "#FAF0CD",
  textTransform:'none'
};
const uploadedView = {
  flexDirection: "row",
  display: "flex",
  alignItems: "center",
  borderRadius: "50%",
  padding: 1,
  color: "#000",
  backgroundColor: "green",
  height: 50,
  width: 50,
  aspectRatio: "1/1",
};
const sxStyleH3 = {
  textAlign: "left",
  fontFamily: "'Poppins', sans-serif",
  fontWeight: "500",
  display: "flex",
};
const sxStyleSmall = {
  textAlign: "left",
  width: "100%",
  fontFamily: "'Poppins', sans-serif",
};
